/* eslint-disable no-shadow */
export enum DataTestids {
  /** Cart **/
  CartCheckout = "a4bb1be00a7042b89ef775a527492a02",
  CartProductPageLink = "1f0f78377a234ea18d023785860833b4",
  // cart > manual entry
  CartSamplesLink = "aee7403c85a04af382ca9ed954ee4dac",
  CartPurchasesLink = "3e969e811309430ca772652ac467d897",
  CartPartNumber = "f315ba17f855457a9875e74bf4679fbc",
  CartManualEntrySubmit = "a31fa42adca147bfb9a748e12eb7e3d4",
  CartManualEntryQuantity = "5d421b3814b74b1fa2eeea1594f9af1c",
  CartManualEntryPartNumber = "17f4ab0196114c6b9e81be5ae833f8c3",
  CartManualEntryForm = "5453838b0cde48ffb4d76f6d544fb535",
  CartManualEntryCustomerReference = "d8ddb357e58540818b861e8157bb4c90",
  CartSplitPackageLinesForm = "72f9efa1a0ce4e21be2dae8e8d09eb8b",
  CartSplitPackageLinesModalApply = "aab14e685fc84a82b8347da092555c3b",
  CartSplitPackageLinesModalClose = "1768eda4c71740d78d5e39160d31dc99",
  CartSplitPackageLineRadio = "f3332c63fd5e49ccba8e0c7655f9e5a8",
  CartSplitSampleLineRadio = "c23b7cac8e5944499cd822f88aa565ea",
  // cart > products
  ProductTableItemQuantityForm = "2df171b3ba8a4a00bdb70b796555d6a2",
  ProductTableItemQuantityInput = "c2a4b3fadc5247219fbbbddda04b4d1d",
  ProductTableItemCustomerReferenceForm = "5d5063942075420fa3d73a1caa2390a5",
  ProductTableItemCustomerReferenceInput = "eb1f102db96d4c2f9617684f3f214cf7",
  ProductTableRowDelete = "49711b5ced654b73816adacdd908f9cc",
  ProductRemove = "a0fa3035b2614a6693c06f373a2d732f",
  ProductAddLimited = "821b8d52ece840e59cb29856b2cdb9ea",
  ProductTablePackTypeDefinitionModalClose = "bced542e49fb4720861605320bd565db",
  // cart > Lead time
  ProductItemLeadTime = "518df2788e3745daa514ed1adb9b4484",
  ProductItemSampleExceed = "804ab136b1d74a3baddd8a22d14f6077",
  // Sample User Registration
  LoaderSampleUserRegistration = "ddcc0a2878754b5b9ede63c58407f66c",
  LoaderSampleUserRegistrationForm = "6a3dee18afaf4a3e8fb70a25abb9c2ad",
  AddressSampleUserForm = "a9460a54f1bf4801beaeccff0809eb90",
  SampleRegistrationContinueButton = "02222ca4b7e94c99800e4c15d97a1c86",
  /** Address **/
  AddressAddNew = "1757b849281e4888857f0c9f9eb24e5e",
  AddressSubmitForm = "db4b4594ad9944f488484babc1f4dd5f",
  AddressCityInput = "1e3eca7633dd434a9c8be67ad3ea9767",
  AddressCityLabel = "c5005e230ed54d6ab4bc6069d5a69baa",
  AddressCompanyNameInput = "a1257a2faca34edc8eca4983750d82b9",
  AddressCompanyNameLabel = "14670690422b402683b7648e93181dfd",
  AddressContactInfoFormButton = "88cf8af61b7145ba813f4bb9879ec301",
  AddressContinueButton = "f9fd4cdeb1354ef8aa98125f11b07f46",
  AddressCountryLabel = "7ee3464a6ea048efa036b4f4ba675c6a",
  AddressCountryOption = "01c283092cf6402e990ea7f609ed8256",
  AddressCountryOptionDefault = "b8b20aff0b084b3f8f9c13202e02fbe1",
  AddressCountrySelect = "014779d36e7546368e38af07d08262dc",
  AddressCreateForm = "dfc5fde3cd4347f2b793b08c7da9c36b",
  AddressEmailInput = "2b26964c459f4dc38fb09472993b82cf",
  AddressEmailLabel = "386cdbf6ed7542f0bc2c13ba2b1a814a",
  AddressFirstNameInput = "103a4d7777f94d49ad6ea2b817556b96",
  AddressFirstNameLabel = "951cbc9964d944cf9623a1654f67ac8c",
  AddressForm = "defb1c48adf041a29b64df54618e1159",
  AddressLastNameInput = "9cd8534ccf29480eacf5dc1d087607c2",
  AddressLastNameLabel = "ff40e4b1807e468a90bb8af3ad264b24",
  AddressLine1Input = "f1d0a4b9392c409a87b871f77a286910",
  AddressLine1Label = "c0005ebdf8ff470cbf7b6a3501833bca",
  AddressLine2Input = "6a540205134042578acc2f20d9d18c4c",
  AddressLine2Label = "eafe3efa62354b5c8bc4da3790dd4c30",
  AddressLine3Input = "83fecc49ad0e4230ac253c7ae984ba64",
  AddressLine3Label = "919c0cda81dc40acb95b1fc5b4681a2d",
  AddressAcceptPartnerMarketing = "e38789c0552d48d8a358cf4640fca795",
  AddressPhoneInput = "5bd7bd6aad3c4c78b65eff800bd01a37",
  AddressPhoneLabel = "39f8a86056fb43b1b16817bb8a1f39cc",
  AddressPostalCodeInput = "c5e6ed50f6fa465b92cf18e405d322fb",
  AddressPostalCodeLabel = "7cba8dd7f3914c80b17f566a74672398",
  AddressPostalCodePlus4Input = "f8bfd961e55c4d4ab319116411ddd026",
  AddressSelection = "03433472c4ad415a97af4d325909627a",
  AddressStateLabel = "184c880258a743468dbe5407b9ed0919",
  AddressStateOption = "87df5c2cb94743a79cc9730d29b7fe00",
  AddressStateOptionDefault = "98edac6774934d3194cf6af87527e431",
  AddressStateSelect = "bef149da8e8e476fb4bd3ccc1908bfb4",
  AddressSubmitCreate = "0038c25179c147c086cae3cdad891d2c",
  AddressVatLabel = "883155001de54c0fbb629e15d92360d3",
  AddressVatInput = "4053029a06824df0bb7f93bff7359180",
  AddressProvincialRegistrationLabel = "a1b2c3d4e5f64a7b8c9d0e1f2a3b4c5d",
  AddressProvincialRegistrationInput = "b2c3d4e5f6a74b8c9d0e1f2a3b4c5d6e",
  AddressVatFieldLabel = "97b9079e81284081b0318516e379d2ee",
  AddressVatFieldInput = "05fc99174a7a4185a4fb58323f13d345",
  AddressVatInvoiceType = "fbc73e2c0c284c70840d063766feff4e",
  AddressVatDeductible = "2129989fec17430e8b97c1352e293fd0",
  AddressVatNonDeductible = "f9bf841c44264cf2a3eb1b896c0d3cd1",
  AddressVatInvoiceName = "7e1cd619f4a0441184e70286b6cb3ba",
  AddressVatRegistrationAddress = "a247d712385e4e108622df761aba8ff7",
  AddressVatBankAccount = "0ca7ec4ae2824be29e6b4d798a648508",
  AddressVatBankAccountNumber = "21c92145877847cc98befe29af242125",
  AddressVatPhone1 = "e147a580c8d349229ee1f4d8b48101b9",
  AddressVatAddressFormToggle = "139058e57be8490ea6410fa15128347f",
  AddressVatFirstName = "095aa54236e340f2ae8e86fc2987f24b",
  AddressVatLastName = "a08220b151cd4cad8072661984843351",
  AddressVatCompanyName = "065e3769ef90400ca675e44e8e1deafc",
  AddressVatProvince = "833835959085402c9a4083860866c8e9",
  AddressVatCity = "1c23e8990a8f48f981baaf469785d8fc",
  AddressVatPostalCode = "85647b45ce77422a83200ca580ad1ca6",
  AddressVatAddress1 = "e93a5645761b4ee992671f977d894f50",
  AddressVatAddress2 = "4f64e34e500b4bfd8d5f4c911f057d74",
  AddressVatPhone2 = "51751dcaabe0467885211f0c01fa0323",
  AddressDefinitionModalClose = "787882f917eb41c98a9ff7143656e8b8",
  AddressCancelCreate = "1c9de9c091f64dfdbd41448c2b817202",
  AddressSelectionForm = "3507cb6936974441b308c4b896ed20c7",
  ExportCustomerType = "2cfb924744e34dbd80ce87df343019a2",
  ExportCompanyName = "40de419818eb4e26b2b4e0e77f4b0755",
  ExportAddress1 = "3c0f53cd1e814b489a83b67646f8fc29",
  ExportAddress2 = "ca9e2ee9e13345e8953634f4feafb600",
  ExportAddress3 = "9af233101b4b43379a57f18d83a42b96",
  ExportCity = "b21bffdaccfb4c529baa0fded6ed2246",
  ExportState = "89f3764af6804eea984b2a2f8c13b7cb",
  ExportPostalCode = "b494c4a28b444af5be07e9deb085b8f7",
  ExportPostalCodePlus4 = "53d4ed537afe40faa4ad7ae52e31b418",
  ExportCanadaYesNo = "a0cf2251754d49bbaa38c200bb78e770",
  ExportCanadaYes = "85d786c62d5246779b39058a3bbbdd99",
  ExportCanadaNo = "06968c18628f4161bb9f8efbc52a84af",
  ExportCompanyDescription = "217436bfe6914177ba72bf4a21fc8d40",
  ExportManufacturingCountry = "1b88b094020e4c408cedf10e0f7db7e5",
  ExportResoldYesNo = "0f9a58ffb9bf4af987ae0f5a7b5d93b8",
  ExportResoldYes = "cd69c160333640538139e6652bab95b7",
  ExportResoldNo = "e256ed158a44483cba0f639bfeda8914",
  ExportScrollToLink = "bc5bc44da5544208b4a35ac48e9c01a2",
  ExportApplicationUse = "6656fd2326aa4ea79b53843bb16fe217",
  ExportSubApplicationUse = "6656fd2326a56ea79b53843bb16fe300",
  ExportAdditional = "e86c17e9ee5441d0b308f5aab09c05ef",
  ExportUltimateConsignee = "03614234ad1748ec9ec6c7840f6f4648",
  ExportConsigneeCountry = "d20803dbf16b41d6ad4e3c6646ea0790",
  ExportConsigneeApplication = "9958c3e6c1ed4307a7389bcb9697ca8f",
  ExportConsigneeSubApplication = "594c1cff215544458b9303a59cc0caff",
  ExportConsigneeAdditional = "8cec11793ef14948ab337fa60d7c0ed9",
  ExportNewConsignee = "e86bc6721d0943fea7d7dae088a3a52b",
  ExportOptionDefault = "22393ee5f3e84224aa904c81be86c95c",
  ExportSelectOption = "e4b707a367bc40f4a8851f3076c30691",
  ExportUSLaw = "0054dc533289401991cbf405b0228472",
  /**Release option */
  SelectReleaseOption = "34ba15196c174f68abb0ae0424546ca0",
  SelectSingleShipment = "eb33cce0cc05469a9b4c7903a8723461",
  SelectDoubleShipment = "b2c0bfc974674d12abc64754b7b03725",
  SelectMultipleShipment = "83606d080aef44a0bdd995c59a669de3",
  ShipmentNote = "06fcdfee92a24a2fbbaadbb3c35969d2",
  /** Shipping **/
  ShippingBackToCart = "85daa93514964e1593af0a827743ec12",
  ShippingCloseLineItems = "4421f999f2fb4c6cb6fc78af09ac7c7c",
  MarketPlaceShippingCloseLineItems = "4421f999f2fb4c6cb6fc78af09ac7c7d",
  ShippingContinueButton = "c5e8ab025512428f901112ddf97c3eb2",
  ShippingCost = "96a0518d26a143b4aafd42d15ca7ce64",
  ShippingForm = "ac54e278f33a46c886d4123bccd5dcbb",
  ShippingHelpSupport = "149f7e18b4c64d3abeb683d779192352",
  ShippingInformationEdit = "dec0674a23434762b31c204352b07abc",
  ShippingOptionsSamplesLink = "ce2ff1485c284ad7b4ba346a5eaef9fd",
  ShippingOptionsMarketPlaceLink = "ce2ff1485c284ad7b4ba346a5eaef9fe",
  ShippingPurchaseOptionInput = "505d8fd5d66848769dd9b66e76675783",
  MarketPlaceShippingPurchaseOptionInput = "505d8fd5d668487f34j9b66e76675783",
  ShippingPurchaseInStockOptionInput = "b196b176cf2241ddb810abc0e4a79a1d",
  ShippingPurchaseBackOrderOptionInput = "bf28d7d8f3454447b7d8b63ca0446e0b",
  ShippingMarketplaceOptionInput = "d1cbbf8e7b1a4c9e8b7f0c8d2a5e6f4a",
  ShippingReturnToCart = "83f66a1f99a54ca9b9699a04bff0454e",
  ShippingSampleOptionInput = "2ac232663cc74884a3e25510c2c6407a",
  ShippingViewLineItems = "35244d5e634c4f6288c5fa972474a7bb",
  MarketPlaceShippingViewLineItems = "35244d5e634c4f6288c5fa972474a7bc",
  ShippingBillToCourier = "bd7ffed36fb94225a5fec8c2016f015a",
  ShippingCourier = "4d21203b9a064acfa45cb1acb395b37c",
  ShippingCourierOption = "9b4c548a8eeb42938cbb28dcad07faa5",
  ShippingAccountNumber = "9206c4eaa90349cf9cbbc55419f9471e",
  ShippingThirdPartyAccount = "520c99b92f2a421cbaf67ef08d868ed3",
  /** Sample */
  SampleContinueButton = "7429defbdc5f43bcb3980cdb89987a15",
  SampleDefaultSelectOption = "5006eb19aaee48cbbd7df00c7abc0661",
  SampleForm = "c48655e362394412a2c9b1b22652aeaf",
  SampleQuestionInput = "f741f0b3f1894f90a8765f625433c6e9",
  SampleQuestionLabel = "76dd26c5007246568ad3117bff844344",
  SampleQuestionSelect = "56a408a6467241b4b523b20547efa1bb",
  SampleQuestionSelectOption = "77b3f1e9c3ac4974bdc92aa94346c0ac",
  SampleQuestionSelectOptions = "6cd5f767cd9c49dabfcce4606609ac34",
  SampleQuestionTextarea = "ab3a8c883421454e9712f116ea76f59b",
  SampleQuestionDatePicker = "0c800fb51ecd4f9da79baa069adc4132",
  EndCustomerShippingSameCheckbox = "5698c13b6229437ea82fa866b843fc3f",
  EndCustomerShippingSameLabel = "60033c5923af4ca58d63461a3e2f4f76",
  /** Sidebar */
  SidebarAgreeToTerms = "7dd4c0627a254f379010963f311aa33b",
  SidebarCheckoutButton = "07c4ee5515ae46c38f0a8e305422ced3",
  SidebarConsentToTransfer = "041b17386aa649c49d2691be76a9033b",
  SidebarAgreeToSample = "fb0b3a5882ef4e83b318ba2405fe460d",
  SidebarForm = "44b9f1581b93422d9ba045dd53f883a9",
  SidebarLogin = "2c950d963a8946549c099e44ce5a2bcb",
  SideBarPoweredByDGK = "113a56580b334279a87299e7f8ed2511",
  /** Payment */
  BillingAddressForm = "56b43e6033e248ae909c719ab573e836",
  BillingPaymentContinueButton = "133c757437a143ba86f97e5da86ec5b3",
  BillingPurchaseOrderInput = "fe05333010ad445fac5bd15906e547ad",
  BillingPurchaseOrderLabel = "1bc66e7365bc4dd48ea8297c3aece1f4",
  BillingShippingSameCheckbox = "327cf7984a09461daac0e1e40674f92d",
  BillingShippingSameLabel = "5f2eeb8e0ca94bc7a2e32e4ba0ae3dff",
  PaymentCardTrashSaved = "a554337fb42742deafb26c43ceacad3f",
  PaymentReferenceNumber = "6a78e55ec7e84a53b41b5442fb8c9d84",
  PaymentSavedContinue = "f0751a5cb16d4d179332cc3a08a88a23",
  PaymentSavedForm = "496f7998f3cd4c5394a1ec2f995c11d9",
  PaymentTransactionNumber = "a6156c5198134213b85de99b9b02515f",
  PaymentDebitCreditCardButton = "jh7ghxvcjhz8hbzjxhcbz76868uhxbcjhz87",
  PaymentGPayButton = "f68cc4e1450f486bb877ea04a460d5ec",
  PaymentApplePayButton = "33a3814169144cdf8fc752627492d54e",
  PaymentPayPalButton = "a91fa32c219a4581a300c0fb26e6b85a",
  /** Preview */
  PreviewSectionEditLink = "513ad0a94529478faa7147c30c433df8",
  PreviewOrderSubmit = "3bbdbcc0e67942b1a317ade78d38f958",
  PreviewPartnerPrivacyPolicy = "c093d5e446ee42b1ae50a278008fc480",
  PreviewSubmitForm = "54be387abd1d46dc98122f90262fbe81",
  /** Success */
  SuccessPrintLink = "f4ca85ba233d4bd891f4c89cee616df4",
  SuccessDownloadLink = "ef56647a92304318b0f49b6c9385cbef",
  SuccessNewCartLink = "21f73be0d1c44ed7b4869405042c43a1",
  /** Error */
  TryAgainButton = "5471e9641c19484c9a7f066ab92db97f",
  /** Not Found */
  NotFoundBackButton = "2662d30e0ec347eea45735ad3926bf54",
  NotFoundHomeButton = "208c06a2499547f6a670fb67d089ee9e",
  NotFoundHomeLink = "8d051a39b7a14d8cb480358cd9bbc6d7",
  /** Loaders */
  LoaderAddress = "2837f507b6414ae18f829c2e1bf89a14",
  LoaderBillingAddressPage = "d8d3d1f8862f47f28fb5277e2ddfb439",
  LoaderCountryStates = "47a5a7bdf89342149873a0852256d4a9",
  LoaderIFrameSavedPage = "b7ea5e4d451843e7a46debc0dfe7a37f",
  LoaderManualEntryForm = "511e1039fc6c49c999cb549d6160bf02",
  LoaderManualEntryFormProvider = "6f68490339254cebac75473c896fdc3b",
  LoaderNewAddressFormProvider = "fa55899fe7cf4d449c0f8105a1356e45",
  LoaderOrderSubmitButton = "2a92d055813745ca9321bd0c89399b7b",
  LoaderOrderSubmitForm = "9808346ea44b4e188930cae966d28992",
  LoaderPhrases = "e45c06138b5f4cbeb976b8887d66da05",
  LoaderProductTableItem = "28046db76bd74a89968f3377fccd8f73",
  LoaderProductTableItemDetail = "bf14417c66de4e3c8b1e88819534ad83",
  LoaderProductTableItemQuantity = "422b872301e54699ac681aca1e708113",
  LoaderReferenceSectionTitle = "a44fc7902b7544ae89c3d5ad0f4ad9a2",
  LoaderSample = "626d795e3eb54a7db203d1ad113fb9bf",
  LoaderSampleQuestions = "8befa068ae7d4075a607d56497b63a51",
  LoaderSavedAddress = "74a4e02d497d454ab997cecad1e9ffc3",
  LoaderShipping = "654c611cabc9494b90e987e651681a6a",
  LoaderSidebarTermsFormProvider = "f620311cce574d439a3705bfed556c46",
  LoaderSplitPackageFormProvider = "5a1dd0f2d26f4b57b69dc210f8613eb4",
  LoaderSplitSampleFormProvider = "25d2001612414549ab099aeb778d5ab8",
  LoaderUseIFrameUrl = "6cb5691f683e42b1bbf863560e5ce2a8",
  LoaderUseInitializeCartState = "e7d339187589403da696e4c07d9b363b",
  LoaderUseLoadCardTypes = "9c93a7f6735c4ac8835d68cd3fa75948",
  LoaderUseLoadShippingOptions = "69c9e8efef07469e82a28c855f061663",
  LoaderUseSubmitOrderAction = "ee5b06bfdc144ace830a9294fb85db5c",
  LoaderUseToSaveBillingListener = "0ca45d9e28f641a5a753e5a07f02aa53",

  /** Sample Courier third party */
  ShippingBillToSampleCourier = "cedf28c43e5c48d1a3dbdfab74a9d766",
  SampleShippingCourier = "d9bd02abdcb246b5a28c121ab2c904c3",
  SampleShippingAccountNumber = "4b15166598914abdaab5a89c31772804",
  SampleShippingThirdPartyAccount = "f47245c39eba450c85719d1a06739f6e",
  SampleAddressCountrySelect = "24152dac8c6c4a73be7ea93edfc2c509",
  SampleAddressCompanyNameInput = "f36500587e5347ebb9a07f9031b5a99e",
  SampleAddressLine1Input = "5fe6385df6554288a1ba2f81b2b5dedb",
  SampleAddressLine2Input = "a72cc3a1b6b149bdbc80355be6019d25",
  SampleAddressLine3Input = "afa668fc26544115a0a6a5acdca75b4a",
  SampleAddressCityInput = "e23500b656a24aebbeef5ccb139a0bf6",
  SampleAddressStateSelect = "bef37ffd003249e896a29244bfde9e5e",
  SampleAddressPostalCodeInput = "140eee7472f64c56b60340017d62e1a2",
  SampleAddressPostalCodePlus4Input = "e9e95719c10b451c8d1b34e969ef2c81",

  /** Sample Route */
  SampleHomeButton = "f4ca85ba233d4bd891f4c89cer616df4",
  SampleHomeLink = "8d051a39b7a14d8i3k80358cd9bbc6d7",
}
